import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M16.25 7.5 10 13.75 3.75 7.5"
	})
});
export default SvgChevronDown;
